import { Component, Input } from "@angular/core";

@Component({
    selector:"app-mb-content-container",
    templateUrl: "./mb-content-container.component.html",
})
export class MBContentContainer{
    @Input() class = '';
    @Input() py = false
}